module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bg"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c6a094a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Background.vue
// module id = 25
// module chunks = 1